import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import em from 'polished/lib/helpers/em';
import styled from 'styled-components';

const TagWrapper = styled.div`
  text-align: center;
`;

const TagItemList = styled.ul`
  margin-bottom: 5em;
  margin-top: -2em;
`;

const TagTitle = styled.div`
  margin-bottom: 2em;
  span {
    text-transform: uppercase;
    display: block;
    font-size: 2.1em;
    line-height: ${em(2.8, 2.1)};
  }
`;

const TagItem = styled.li`
  display: inline-block;
  margin-right: 1em;
  margin-top: 2em;
  
  &:last-child {
    margin-right: 0;
  }
`;

const FilterLinkButton = styled.span`
  display: block;
  a {
    font-family: Flow-Inverted;
    text-transform: uppercase;
    font-size: 2.1em;
    display: block;
    white-space: nowrap;
    padding: ${em(1.5, 2.1)} ${em(1.5, 2.1)} ${em(1, 2.1)};
    border: ${em(0.1, 2.1)} solid ${props => props.theme.highlightColor};
    border-radius: ${em(3, 2.1)};
    background-color: white;
    transition: all 0.3s ease-out;
    
    &:${props => props.theme.hoverProperty} {
      background-color: ${props => props.theme.highlightColor};  
    }
    
    &.active {
      background-color: black;
      color: ${props => props.theme.highlightColor};
    }
  }
`;

const TagLink = ({
  tag,
  currentTags,
  children,
  onClick
}) => {
  return (
    <FilterLinkButton>
      <a href="#"
         className={currentTags.indexOf(tag) !== -1 ? 'active' : ''}
         onClick={e => {
           e.preventDefault();
           onClick(tag);
         }}
      >
        {children}
      </a>
    </FilterLinkButton>
  )
};

interface Props {
  tags?: {name: string}[];
  tagsUpdated?(tags: string[]): void;
  allowOnlyOne?: boolean;
}

interface State {
  activeTags: string[];
}

export class TagList extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      activeTags: []
    }
  }

  private _updateTags = (tag: string) => {
    const {
      tagsUpdated,
      allowOnlyOne
    } = this.props;

    let activeTags: string[]
    if (!allowOnlyOne) {
      activeTags = this.state.activeTags;
      let tagIndex: number = activeTags.indexOf(tag);
      if (tagIndex === -1) {
        activeTags.push(tag);
      } else {
        activeTags.splice(tagIndex, 1);
      }
    } else {
      activeTags = !this.state.activeTags.includes(tag) ? [tag] : [];
    }

    this.setState({activeTags}, () => {
      if (tagsUpdated) {
        tagsUpdated(this.state.activeTags);
      }
    });
  };

  render() {
    const { tags } = this.props;

    return (
      <TagWrapper>
        <TagTitle><FormattedMessage id={'artists.tagFilterTitleLabel'} /></TagTitle>
        <TagItemList>
          {tags.map((tag: {name: string}) =>
            <TagItem key={tag.name}>
              <TagLink
                tag={tag.name}
                currentTags={this.state.activeTags}
                onClick={(tag: string) => this._updateTags(tag)}
              >
                {tag.name}
              </TagLink>
            </TagItem>
          )}
        </TagItemList>
      </TagWrapper>
    )
  }
}


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/tags/tags.tsx